import React, { createContext, useCallback } from 'react';
import axios from 'axios';
import { JAVA_BACKEND_API_URL, getAuthHeader } from "../BackendConstants";
import { currentLanguageId } from "../../../i18n";
import { fuarService } from "../../../services/fuarService";
import i18n from "../../../i18n";

const FairContext = createContext();

// /fuar/list ve /fuar/selectable aynı öğe şeklini döner (backlog #187).
const mapFair = f => ({
    id: f.fuarId,
    nameTR: f.fuarName,
    nameEN: f.fuarName,
    start_date: f.fuarStartDate,
    end_date: f.fuarEndDate,
    logo: f.fuarLogo,
    logoUrl: f.fuarLogoUrl, // backlog #18 — FuarLogoImg bunu gösterir, logo yalnızca eski backend için
    areaName: f.fuarAlaniName,
    group: f.fuarGroup,
    detay: f, // #561: the whole list item (stage dates and times), for FuarBilgisiModal
});
// Mock fuar listesi - API çalışmadığında kullanılır
const MOCK_FAIRS = [
    {
        id: 3,
        nameTR: "EMITT 2025",
        nameEN: "EMITT 2025",
        start_date: "2025-01-23",
        end_date: "2025-01-26",
        logo: "emitt2025_logo.png",
        areaName: "İstanbul Fuar Merkezi",
        group: "ACTIVE", // backlog #45/#46 group taxonomy — mock data stays pickable in the Header modal
    },
    {
        id: 4,
        nameTR: "IDEF 2025",
        nameEN: "IDEF 2025",
        start_date: "2025-05-15",
        end_date: "2025-05-18",
        logo: "idef2025_logo.png",
        areaName: "TÜYAP Fuar ve Kongre Merkezi",
        group: "ACTIVE",
    },
];

export const FairProvider = ({ children }) => {

    // GET /api/v1/fuar/list?languageId=1[&group=]
    // Backlog #45: group is one of FuarGroupConstant's values (FUTURE/ACTIVE/CURRENT_YEAR/
    // PREVIOUS_YEAR/PAST_3Y/ARCHIVED) or 'ALL'; omitted means the backend's own default (everything
    // except ARCHIVED). Backlog #44: every mapped fair now carries its `group` so callers (the Header
    // fuar switcher) can filter/prioritize without a second request.
    const getFairs = useCallback(async (group) => {
        const token = localStorage.getItem('token');

        // Token yoksa API'ye gitme, mock data döndür
        if (!token) {
            console.warn("getFairs: token yok, mock data kullanılıyor.");
            return { data: MOCK_FAIRS, totalPages: 1, totalRecords: MOCK_FAIRS.length };
        }

        try {
            const response = await axios.get(`${JAVA_BACKEND_API_URL}/fuar/list`, {
                // WAS (until #332): params: group ? { languageId: 1, group } : { languageId: 1 },
                params: group ? { languageId: currentLanguageId(), group } : { languageId: currentLanguageId() },
                headers: getAuthHeader(),
            });

            const mapped = response.data.map(mapFair);

            return { data: mapped, totalPages: 1, totalRecords: mapped.length };
        } catch (error) {
            console.warn("getFairs API hatası, mock data kullanılıyor:", error.message);
            return { data: MOCK_FAIRS, totalPages: 1, totalRecords: MOCK_FAIRS.length };
        }
    }, []);

    // GET /api/v1/fuar/selectable — backlog #187: the fairs the logged-in user may pick (a firma
    // account: only its company's fairs, past ones included, newest first). No mock fallback — a
    // firma user must never be offered a fair outside that list; errors reach the caller.
    const getSelectableFairs = useCallback(async () => {
        const list = await fuarService.getSelectableFuarList();
        return list.map(mapFair);
    }, []);

    // GET /api/v1/fuar/activefuarbyuserid/{userId}
    const getActiveFair = useCallback(async (userId) => {
        const token = localStorage.getItem('token');
        if (!token || !userId) {
            console.warn("getActiveFair: token veya userId yok.");
            return null;
        }
        try {
            const response = await axios.get(
                `${JAVA_BACKEND_API_URL}/fuar/activefuarbyuserid/${userId}`,
                { headers: getAuthHeader() }
            );
            return response.data;
        } catch (error) {
            console.warn("getActiveFair API hatası:", error.message);
            return null;
        }
    }, []);



    // Backlog #43/#44 (2026-09-18): the backend now takes the caller's userId from their OWN
    // session, never from the request body — a user may only switch their own active fair. The
    // `userId` param stays (existing callers still pass their own id and it's harmless in the log
    // line above), but it is no longer sent in the body: sending it implied the endpoint could target
    // someone else, which is exactly the security hole #43 closed.
    // Backlog #187: the PUT itself now lives in fuarService.setActiveFuar (MainContext's post-login
    // auto-select needs it too, and MainProvider sits above FairProvider). A firma account picking a
    // fair outside its company's list gets a 403, rethrown there as a readable Turkish Error that
    // callers show as-is.
    const activateFair = useCallback(async (userId, fairId) => {
        try {
            console.log('📌 activateFair çağrısı:', { userId, fairId });

            const token = localStorage.getItem('token');
            const xUserId = localStorage.getItem('userId');

            if (!token || !xUserId) {
                throw new Error(i18n.t("components:fairContext.tokenVeyaUserIdBulunamadi"));
            }

            const data = await fuarService.setActiveFuar(fairId);

            console.log('✅ Fuar aktif edildi:', data);
            return data;
        } catch (error) {
            console.error('❌ Fuar aktif etme hatası:', error);
            throw error;
        }
    }, []);


    // Fuar seçimi - localStorage'a kaydet
   // const activateFair = useCallback(async (userId, fairId) => {
      //  try {
         //   console.log('📌 activateFair çağrısı:', { userId, fairId });

            // Backend'e PUT isteği yap
           // const response = await axios.put(
             //   `${JAVA_BACKEND_API_URL}/fuar/update/${fairId}`,
               // {
                 //   userId: parseInt(userId),
                   // isActive: true
                //},
                //{ headers: getAuthHeader() }
           // );

            //console.log('✅ Backend güncellendi:', response.data);

            // Hemen localStorage'a kaydet (getActiveFair'ye bağımlılık yok)
          //  localStorage.setItem('activeFairId', String(fairId));
            //console.log('✅ localStorage güncellendi:', fairId);

            //return response.data;
        //} catch (error) {
          //  console.error('❌ activateFair hatası:', error.response?.data || error.message);
            //throw error;
        //}
   // }, []);




    return (
        <FairContext.Provider value={{ getFairs, getSelectableFairs, getActiveFair, activateFair }}>
            {children}
        </FairContext.Provider>
    );
};

export default FairContext;